<template>
	<div>
		<div class="d-flex-between-center m-d-8">
			<div class="d-inline">
				<span class="f-regular f-14 f-c-black">Subtotal</span>
			</div>
			<div class="f-regular f-14 f-c-black" v-if="transaksi.detail_transaksi.tarif_tambahan > 0">
				{{ formatRupiah(transaksi.detail_transaksi.tarif_tambahan.toString()) }}
			</div>
			<div class="f-regular f-14 f-c-black" v-else>
				{{ formatRupiah(transaksi.detail_transaksi.total.toString()) }}
			</div>
		</div>

		<!-- snap clean promo -->
		<div class="d-flex-between-center m-d-8" v-if="isSnapCleanPromo()">
			<div class="d-inline">
				<span class="f-regular f-14 f-c-black">Diskon Promo</span>
			</div>
      <div class="f-regular f-14 f-c-black">
        {{ formatRupiah(isSnapCleanPromo()) }}
      </div>
		</div>

		<!-- Diskon -->
		<div class="m-d-8" v-if="transaksi.detail_transaksi.diskon_nominal > 0">
			<div class="d-flex-between-center">
				<div class="d-inline">
					<span class="f-regular f-14 f-c-black">Diskon</span>
				</div>
				<div class="f-regular f-14 f-c-black">
					(-) {{ formatRupiah(transaksi.detail_transaksi.diskon_nominal.toString()) }}
				</div>
			</div>
			<div class="d-flex-between-center f-c-midgrey f-12" v-if="transaksi.promo?.discount_transaction?.discount_value ?? 0 > 0">
				<div class="d-inline">
					<span>{{ transaksi.promo.meta.name }}</span>
				</div>
				<div>
					(-) {{ formatRupiah(transaksi.promo.discount_transaction.discount_value.toString()) }}
				</div>
			</div>
		</div>

		<!-- Pajak -->
		<div class="d-flex-between-center m-d-8" v-if="transaksi.detail_transaksi.pajak_persen > 0">
			<div class="d-inline">
				<span class="f-regular f-14 f-c-black">Pajak</span>
				<span class="f-regular f-14 f-c-midgrey">  •  {{ transaksi.detail_transaksi.pajak_persen }}%</span>
			</div>
			<div class="f-regular f-14 f-c-black">
				{{ formatRupiah(transaksi.detail_transaksi.pajak_nominal.toString()) }}
			</div>
		</div>

		<!-- pengantaran -->
		<div class="d-flex-between-center m-d-8" v-if="transaksi.detail_transaksi.transaksi_loyalty">
			<div class="d-inline">
				<span class="f-regular f-14 f-c-black">Pengantaran</span>
			</div>
			<div class="f-regular f-14 f-c-black">
				{{ formatRupiah(transaksi.detail_transaksi.pengantaran_extra.biaya.toString()) }}
			</div>
		</div>

		<!-- Biaya layanan -->
		<div class="d-flex-between-center m-d-8" v-if="transaksi.detail_transaksi.biaya_service > 0">
			<div class="d-inline">
				<span class="f-regular f-14 f-c-black">Biaya Layanan</span>
			</div>
			<div class="f-regular f-14 f-c-black">
				{{ formatRupiah(transaksi.detail_transaksi.biaya_service.toString()) }}
			</div>
		</div>

		<!-- Pengantaran -->
		<div class="d-flex-between-center m-d-8" v-if="transaksi.detail_transaksi.biaya_kirim > 0">
			<div class="d-inline">
				<span class="f-regular f-14 f-c-black">Pengantaran</span>
			</div>
			<div class="f-regular f-14 f-c-black">
				{{ formatRupiah(transaksi.detail_transaksi.biaya_kirim.toString()) }}
			</div>
		</div>

		<!-- Tarif Tambahan -->
		<!--<div class="d-flex-between-center m-d-8" v-if="transaksi.detail_transaksi.tarif_tambahan > 0">-->
		<!--	<div class="d-inline">-->
		<!--		<span class="f-regular f-14 f-c-black">Tarif Tambahan</span>-->
		<!--		<span class="f-regular f-14 f-c-midgrey">  •  {{ transaksi.detail_transaksi.tarif_kali }}%</span>-->
		<!--	</div>-->
		<!--	<div class="f-regular f-14 f-c-black">-->
		<!--		{{ formatRupiah(transaksi.detail_transaksi.tarif_tambahan.toString()) }}-->
		<!--	</div>-->
		<!--</div>-->

		<div class="separator-line-dot m-t-4 m-d-16"></div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanBiayaTambahan",
	props: {
		transaksi: Object,
	},
	methods: {
		isHaveDiscount() {
			return this.transaksi?.promo?.discount_transaction
		},
		isSnapCleanPromo() {
			return this.transaksi?.promo?.amount_promo ?? 0
		}
	}
}
</script>